import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from '../shared/service/message.service';
import { VsCrudService } from '../shared/service/vs-crud.service';
import { Resultado } from '../shared/util/resultado.model';
import { Dashboard } from './dashboard.model';




@Injectable()
export class DashboardService extends VsCrudService<Dashboard> {
  
    public url: string = "api/dashboard";

    constructor(_http: HttpClient, _message: MessageService) { 
        super(<any>_http, _message);
    }
   
    public totalVendasRealizadas(lojaId: Number, periodo: Array<String>) {        
        return this.get(`${this.url}/totaisDashboard/${lojaId}/${periodo}`).toPromise().then(res => 
              <Dashboard>res);     
    }

    public consultarCertificado(lojaId: Number) {        
        return this.get(`${this.url}/certificado/${lojaId}`).toPromise().then(res => 
              <Resultado>res);     
    }

    public consultarQtdeContratos() {        
        return this.get(`${this.url}/contratos/qtde`).toPromise().then(res => 
              <Resultado>res);     
    }


}


